import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { GridModule } from '../../../grid/grid.component.module';
import { PaginatorModule } from '../../../paginator/paginator.module';
import { ReportDetailComponent } from './report-detail.component';

@NgModule({
    declarations: [ReportDetailComponent],
    imports: [CommonModule, TranslateModule, TwcModule, GridModule, PaginatorModule],
    exports: [ReportDetailComponent],
})
export class ReportDetailModule {}
